// extracted by mini-css-extract-plugin
export var avatarContainer = "_ah-0";
export var avatarTypingWave = "_ah-i";
export var gray = "_ah-f";
export var green = "_ah-c";
export var icon = "_ah-9";
export var image = "_ah-1";
export var lg = "_ah-6";
export var md = "_ah-5";
export var presenceDot = "_ah-b";
export var red = "_ah-d";
export var sm = "_ah-4";
export var status = "_ah-a";
export var typingDot = "_ah-h";
export var typingPill = "_ah-g";
export var xl = "_ah-7";
export var xs = "_ah-3";
export var xxl = "_ah-8";
export var xxs = "_ah-2";
export var yellow = "_ah-e";